import React, { useState, useEffect } from "react";
import { Col, Row, Button, Container, Alert } from "react-bootstrap";
import { Link } from "react-router-dom";
import axios from "axios";

const AdminAlerts = () => {
  const [termCheck, setTermCheck] = useState(false);
  const [privacyCheck, setPrivacyCheck] = useState(false);
  const [brandingCheck, setBrandingCheck] = useState(false);
  const [limitCheck, setLimitCheck] = useState(false);
  const [checkClasses, setCheckClasses] = useState(false);
  const [checkClassTypes, setCheckClassTypes] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  // the Admin Alerts
  useEffect(async () => {
    const alertsRequest = await axios.get(`/api/admin/manage/alerts/`, {
      withCredentials: true,
    });
    setTermCheck(alertsRequest.data.termCheck);
    setPrivacyCheck(alertsRequest.data.privacyCheck);
    setBrandingCheck(alertsRequest.data.brandingCheck);
    setLimitCheck(alertsRequest.data.limitCheck);
    setCheckClasses(alertsRequest.data.checkClasses);
    return setCheckClassTypes(alertsRequest.data.checkClassTypes);
  }, []);

  if (termCheck || privacyCheck || brandingCheck || limitCheck || checkClasses || checkClassTypes) {
    return (
      <Container>
        <Row>
          <Col sm='12'>
            <hr />
            {(!limitCheck && !checkClasses && !checkClassTypes) && (
              <div className='text-center'>
                <p>You have alerts or configuration advice.</p>
                {!isOpen && (
                  <Button variant='info' type='button' onClick={() => setIsOpen(true)}>
                    Open
                  </Button>
                )}
                {isOpen && (
                  <Button variant='info' type='button' onClick={() => setIsOpen(false)}>
                    Close
                  </Button>
                )}
              </div>
            )}

            {(isOpen || limitCheck || checkClasses || checkClassTypes) && (
              <div>
                {limitCheck && (
                  <Alert variant='danger' className='text-center mt-3 mb-3'>
                    You have exceeded subscriptions or block booking limits for your plan and will
                    need to upgrade. Please contact the signaclass team to upgrade your plan.
                  </Alert>
                )}
                {checkClassTypes && (
                  <Alert variant='primary' className='text-center mt-3 mb-3'>
                    You have not set up class types. All classes and blocks need a class type so you
                    must do this to get started:{" "}
                    <Button
                      variant='secondary'
                      size='sm'
                      as={Link}
                      to={`/admin/class-types/`}
                      className='ms-2'
                    >
                      Add
                    </Button>
                  </Alert>
                )}
                {checkClasses && (
                  <Alert variant='primary' className='text-center mt-3 mb-3'>
                    You have not set up classes. You should create classes against venues:{" "}
                    <Button
                      variant='secondary'
                      size='sm'
                      as={Link}
                      to={`/admin/venue-list/`}
                      className='ms-2'
                    >
                      Add
                    </Button>
                  </Alert>
                )}
                {termCheck && (
                  <Alert variant='warning' className='text-center mt-3 mb-3'>
                    You do not have any terms and conditions set. Your customers will expect clear
                    terms and conditions:
                    <Button
                      variant='secondary'
                      size='sm'
                      as={Link}
                      to={`/admin/configure/`}
                      className='ms-2'
                    >
                      Add
                    </Button>
                  </Alert>
                )}
                {privacyCheck && (
                  <Alert variant='warning' className='text-center mt-3 mb-3'>
                    You do not have any privacy policy set. Your customers will expect a privacy
                    policy and it is often required by law:
                    <Button
                      variant='secondary'
                      size='sm'
                      as={Link}
                      to={`/admin/configure/`}
                      className='ms-2'
                    >
                      Add
                    </Button>
                  </Alert>
                )}
                {brandingCheck && (
                  <Alert variant='info' className='text-center mt-3 mb-3'>
                    You haven&apos;t set your brand colours to customise the look of signaclass to
                    match your brand:
                    <Button
                      variant='secondary'
                      size='sm'
                      as={Link}
                      to={`/admin/configure/`}
                      className='ms-2'
                    >
                      Add
                    </Button>
                  </Alert>
                )}
              </div>
            )}
            <hr />
          </Col>
        </Row>
      </Container>
    );
  } else {
    return null;
  }
};

export default AdminAlerts;
